<template>
    <div>{{seofun}} 
        <section class="blockElement mainBanner pt-0 pb-4 px-0 ">
                <div class="inner-banner-custom row align-items-center justify-content-center">
                    <div class="text-center middleBox">
                        <h2 class="mb-3">{{$t('marktTrdHour_title')}}</h2>
                        <p>{{$t('marktTrdHour_txt')}}</p>
                    </div>
                </div>
        </section>
<!--         <div class=" justify-content-center row align-items-center mb-3">
            <div class="col-12 text-center">
                
            </div>
        </div> --> 
        <div class="row justify-content-center">
            <div class="col-12">
                <div id="services">
                    <p><strong>{{$t('marktTrdHour_table_below')}}</strong></p>
                    <div class="mb-4 whiteBG p-3">
                        <table class="table commodities-table fundingMethodstable table-striped">
                            <thead>
                                <tr>
                                    <th width="250">{{$t('marktTrdHour_Forex')}}</th>
                                    <th>{{$t('marktTrdHour_Open')}}</th>
                                    <th>{{$t('marktTrdHour_Close')}}</th>
                                    <th>{{$t('marktTrdHour_Break')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(value,key) in market_trading_hours[0].market_holidays.Forex">
                                    <td>{{key}} <span v-if="value.small"><small>{{value.small}}</small></span></td>
                                    <td>{{value.Open}}</td>
									<td>{{value.Close}}</td>
									<td>{{value.Break}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mb-4 whiteBG p-3">
                        <!-- <h4>Fall/Winter (March/April - October/November)</h4> -->
                        <table class="table commodities-table fundingMethodstable table-striped">
                            <thead>
                                <tr>
                                    <th width="250">{{$t('marktTrdHour_Indices')}}</th>
                                    <th>{{$t('marktTrdHour_Open')}}</th>
                                    <th>{{$t('marktTrdHour_Close')}}</th>
                                    <th>{{$t('marktTrdHour_Break')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(value,key) in market_trading_hours[0].market_holidays.Indices">
                                    <td>{{key}} <span v-if="value.small"><small>{{value.small}}</small></span></td>
                                    <td>{{value.Open}}</td>
									<td>{{value.Close}}</td>
									<td>{{value.Break}}</td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                     <div class="mb-4 whiteBG p-3">
                        <table class="table commodities-table fundingMethodstable table-striped">
                            <thead>
                                <tr>
                                    <th width="250">{{$t('marktTrdHour_Commodities')}}</th>
                                    <th>{{$t('marktTrdHour_Open')}}</th>
                                    <th>{{$t('marktTrdHour_Close')}}</th>
                                    <th>{{$t('marktTrdHour_Break')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(value,key) in market_trading_hours[0].market_holidays.Commodities">
                                    <td>{{key}} <span v-if="value.small"><small>{{value.small}}</small></span></td>
                                    <td>{{value.Open}}</td>
									<td>{{value.Close}}</td>
									<td>{{value.Break}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
    import { staticJson } from '../../../../../static/fxView/js/staticJson.js' 
    export default {
        name: 'Finacial-Events-global',
        data() {
            return {
				market_trading_hours : []
            }
        },
		computed:{
			seofun(){
				this.market_trading_hours = staticJson
			}
		},
		created(){
			
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/tools/pages/market_trading_hours.vue